import { API_URL } from '../../config';

export const BRANCHES = [
  'Headquarters',
  'Adenta',
  'Sunyani',
  'KNUST',
  'Not a member',
];

export const REGISTRATIONS_PER_PAGE = 20;

export const getAdminHeaders = (includeJson = false) => {
  const headers = {};
  const token = localStorage.getItem('token');

  if (includeJson) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export const fetchAdminJson = async (path, options = {}) => {
  const response = await fetch(`${API_URL}${path}`, options);
  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || 'Request failed');
  }

  return data;
};

export const downloadDataUrl = (dataUrl, filename) => {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatCurrency = (value = 0) =>
  `GHC ${Number(value || 0).toFixed(2)}`;

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString() : 'N/A';

export const formatDateTime = (value) =>
  value ? new Date(value).toLocaleString() : 'N/A';

export const getParticipantCount = (registration) =>
  1 +
  (registration.hasSpouse && registration.spouseInfo?.name ? 1 : 0) +
  (registration.children?.length || 0);
